import React, { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

import { Capacitor } from "@capacitor/core";

//Components
import Helmet from "react-helmet";

import FeedManager from "../feed/FeedManager";
import Landing from "../landing/Landing";

import Spinner from "../layout/Spinner";

//Actions
import { initializeFeedType } from "../../actions/feed";

const Home = ({ auth: { isAuthenticated, user, loading, profile }, initializeFeedType }) => {
  //Get query parameters, if any (social login callback)
  //MUI Styling

  const [capacitorPlatform, setCapacitorPlatform] = useState(null);

  const getCapacitorPlatform = () => {
    const platform = Capacitor.getPlatform();

    if (platform) {
      setCapacitorPlatform(platform);
    } else {
      setCapacitorPlatform("web");
    }
  };
  useEffect(() => {
    getCapacitorPlatform();
  }, []);

  // Fallback feed type initialization if not set from auth
  useEffect(() => {
    if (isAuthenticated && profile) {
      // Initialize feed type from user preference or default to trending
      const feedType = profile.feedViewType || "trending";
      initializeFeedType(feedType);
    }
  }, [isAuthenticated, profile, initializeFeedType]);

  const isAuth = (
    <div className="h-full w-full md:w-full md:ml-0 md:pt-4 bg-background md:bg-neutral-50 min-h-screen">
      <Helmet>
        <title>thisPantry</title>
      </Helmet>
      <FeedManager />
    </div>
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated && user) {
    if (user?.signupStage) {
      console.log("Navigating to /welcome/" + user.signupStage);
      return <Navigate to={`/welcome/${user.signupStage}`} />;
    } else {
      return isAuth;
    }
  } else {
    if (!capacitorPlatform || capacitorPlatform === "web") {
      return <Landing />;
    } else {
      return <Navigate to="/signup" />;
    }
  }
};

Home.propTypes = {
  auth: PropTypes.object.isRequired,
  initializeFeedType: PropTypes.func.isRequired,
};

//Bring in state (Map to props)
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { initializeFeedType })(Home);
